import AiBlogGeneratorMain from "../components/AiBlogGenerator/AiBlogGeneratorMain";

const AiBlogGenerator = function AiBlogGenerator() {
  return <AiBlogGeneratorMain />;
};

export default AiBlogGenerator;
